import { computed, inject, Injectable, resource } from '@angular/core';
import { PalletItemRepository } from '../repository/pallet-item.repository';
import { routeParamAsNumber } from '@softline/application';
import { PalletItem } from '../types/pallet-item';

@Injectable()
export class PalletItemService {
  readonly #repository = inject(PalletItemRepository);

  readonly id = routeParamAsNumber('id');

  readonly #resource = resource({
    params: () => this.id() ?? undefined,
    loader: async ({ params: id }) => {
      try {
        return this.#repository.load(id);
      } catch (e) {
        console.log(e);
        return [];
      }
    },
  });

  readonly items = computed(() => {
    if (!this.#resource.error() && this.#resource.hasValue())
      return this.#resource.value();
    return [];
  });

  async open(item: PalletItem): Promise<PalletItem | null> {
    const result = await this.#repository.open(item);
    this.#resource.set(this.updateItem(result));
    return result;
  }

  async complete(item: PalletItem): Promise<PalletItem> {
    const result = await this.#repository.complete(item);
    this.#resource.set(this.updateItem(result));
    return result;
  }

  private updateItem(item: PalletItem): PalletItem[] {
    const value = this.#resource.value() ?? [];
    const index = value.findIndex((p) => p.palette.id === item.palette.id);
    if (index < 0) return value;

    value[index] = {
      ...value[index],
      ...item,
    };

    return [...value];
  }
}
